<template>
  <div data-aos="fade-up">
    <h2 class="primary--text">{{ title }}</h2>
    <p class="pt-2 pb-5">{{ dateCreated }}</p>
    <v-img :src="backgroundImage"></v-img>
    
    <p :class="[{ 'line-clamp-6': !toggle }, 'pt-5 text-justify']" v-html="description"></p>

    <router-link
      :to="{
        name: 'MediaArticle',
        params: {
          id: id,
          title: formatArticleTitle(title)
        }
      }"
    >
      <h3 class="text-right font-weight-bold text-hover mb-10">Read More</h3>
    </router-link>

    <base-horizontal-line></base-horizontal-line>
  </div>
</template>

<script>
  export default {
    name: "ArticleContent",
    props: {
      id: { type: Number },
      title: { type: String, default: '' },
      dateCreated: { type: String, default: '' },
      backgroundImage: { type: String, default: '' },
      description: { type: String, default: '' },
    },
    data: () => ({
      toggle: false,
    }),
    methods: {
      formatArticleTitle(title) {
        return title.replace(/\s+/g, '-').toLowerCase();
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>